import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import EmployeeAccountForm from "./EmployeeAccountForm";
import { AppModal } from "../../../common";
import { createSubAccount } from "../../../account";

const EmployeeAccountFormModal = (props) => {
  const handleSubmitForm = (values) => {
    values.auth_token = props.credentials.authToken;

    props.createSubAccount({ values });
  };

  return (
    <AppModal {...props}>
      <EmployeeAccountForm onSubmit={handleSubmitForm} />
    </AppModal>
  );
};

const mapStateToProps = (state) => ({
  credentials: state.lib_authentication.credentials,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createSubAccount,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeAccountFormModal);
